import { ReactNode } from 'react';

export type useTableProps<T> = {
    data: T[] | undefined;
    initialSortKey: keyof T;
};

export type TableProps = {
    children: ReactNode;
    className?: string;
};

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type ActiveSort<T> = {
    sortKey: T;
    direction: SortDirection;
};
